import { Routes } from "@angular/router";
import { AuthGuard } from "../../shared/authguards/auth.guard";
import { epakRoleGuard } from "../../shared/authguards/epak-role.guard";
import { reviewDraftGuard } from "../../shared/authguards/review-draft.guard";

export const PRESCRIPTION_ROUTES: Routes = [
  {
    path: "prescriptions",
    loadComponent: () => import("./prescription.component").then(m => m.PrescriptionComponent),
    data: { title: "pageTitles.prescriptions" },
    canActivate: [AuthGuard, epakRoleGuard],
    children: [
      {
        path: "",
        loadComponent: () => import("./prescription-list/prescription-list.component").then(m => m.PrescriptionListComponent),
        data: { title: "pageTitles.prescriptions" },
      },
      {
        path: "new",
        loadComponent: () => import("./new-prescription/new-prescription.component").then(m => m.NewPrescriptionComponent),
        data: { title: "pageTitles.newPrescription" },
      },
      {
        path: "review",
        loadComponent: () => import("./prescription-review/prescription-review.component").then(m => m.PrescriptionReviewComponent),
        canActivate: [reviewDraftGuard],
        data: { title: "pageTitles.prescriptionReview" },
      },
      {
        path: "message",
        loadComponent: () => import("../message/message.component").then(m => m.MessageComponent),
        data: { title: "pageTitles.prescriptionMessages" },
      },
      {
        path: "submitted",
        loadComponent: () => import("../../shared/components/submit-confirmation/submit-confirmation.component").then(m => m.SubmitConfirmationComponent),
        data: { title: "pageTitles.submitted" },
      },
    ],
  },
];
